import { Card, Row, Col, Statistic, Typography } from "antd"
const { Text } = Typography

const Leverage = () => {
  return (
    <Row gutter={[16, 16]} style={{ marginBottom: "24px" }}>
          <Col xs={24} sm={12} md={6}>
            <Card style={{ background: "linear-gradient(135deg, #52c41a 0%, #389e0d 100%)", color: "white" }}>
              <Statistic
                title={<span style={{ color: "rgba(255,255,255,0.9)", fontSize: "14px" }}>Radar+ ROI</span>}
                value="8,700%"
                valueStyle={{ color: "white", fontSize: "24px", fontWeight: "bold" }}
                suffix={
                  <div style={{ fontSize: "12px", opacity: 0.9, marginTop: "4px" }}>Paid $199 → Gained $17,400</div>
                }
              />
            </Card>
          </Col>
          <Col xs={24} sm={12} md={6}>
            <Card>
              <Statistic
                title="Profit Change Driven"
                value={34}
                suffix="%"
                valueStyle={{ color: "#1890ff" }}
                prefix={
                  <Text type="secondary" style={{ fontSize: "12px" }}>
                    of monthly profit change
                  </Text> 
                }
              />
            </Card>
          </Col>
          <Col xs={24} sm={12} md={6}>
            <Card>
              <Statistic
                title="Risk Mitigation Saved"
                value="$847K"
                valueStyle={{ color: "#52c41a" }}
                prefix={
                  <Text type="secondary" style={{ fontSize: "12px" }}>
                    automated prevention
                  </Text>
                }
              />
            </Card>
          </Col>
          <Col xs={24} sm={12} md={6}>
            <Card>
              <Statistic
                title="Trend Alert Gains"
                value={23}
                suffix="%"
                valueStyle={{ color: "#722ed1" }}
                prefix={
                  <Text type="secondary" style={{ fontSize: "12px" }}>
                    of financial gains
                  </Text>
                }
              />
            </Card>
          </Col>
        </Row>
  )
}

export default Leverage